import React from 'react';
import { CompleteKundali, Language } from '../types/kundali';
import { ShubhaEssentialsHub, ShubhaTabKey } from './ShubhaEssentialsHub';

export interface RemediesViewProps {
  kundali: CompleteKundali;
  lang?: Language;
  initialTab?: ShubhaTabKey;
  initialSubTab?: 'advisor' | 'general';
}

/**
 * RemediesView (Canonical Consolidation Adapter)
 * Delegates to the unified ShubhaEssentialsHub under Section C (Remedies & Recommendations)
 * or explicit initialTab, ensuring complete backward compatibility for ChartViewer and any legacy callers.
 */
export const RemediesView: React.FC<RemediesViewProps> = ({ kundali, lang = 'en', initialTab }) => {
  return (
    <ShubhaEssentialsHub
      kundali={kundali}
      lang={lang}
      initialTab={initialTab || 'remedies'}
    />
  );
};
